import { render } from "./DetailsInfo.vue?vue&type=template&id=c335982c&scoped=true"
import script from "./DetailsInfo.vue?vue&type=script&lang=js"
export * from "./DetailsInfo.vue?vue&type=script&lang=js"

import "./DetailsInfo.vue?vue&type=style&index=0&id=c335982c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c335982c"]])

export default __exports__